module.exports = __webpack_public_path__ + "img/ICONE-ANNULER.a0b5df8c.svg";